// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".canvas-container{position:absolute!important;top:0;left:0;flex:1 1 auto}.canvas-container,.canvas-container canvas{width:100%!important;height:auto!important}", ""]);
// Exports
module.exports = exports;
